import { useMutation, useQueryClient } from "@tanstack/react-query"

import { FINANCE_RETURN_FUNDS_QUERY_KEY } from "@/constants/query"
import { changeReturnStatus, changeReturnStatusByAdmin, createCustomerFinanceReturnFunds, createFinanceReturnFunds } from "@/http/financeReturnFunds"

import { useMessage } from "@/hook/useMessage"


export const useFinanceReturnFundsMutation = () => {
  const client = useQueryClient()
  const { Success, Error, Process } = useMessage(FINANCE_RETURN_FUNDS_QUERY_KEY)

  const onSuccess = () => {
    client.invalidateQueries([FINANCE_RETURN_FUNDS_QUERY_KEY]).then()
    Success()
  }

  const onMutate = () => {
    Process()
  }

  const onError = (e: any) => {
    Error(e)
  }

  const createMutation = useMutation({
    mutationFn: createFinanceReturnFunds,
    onSuccess: () => onSuccess(),
    onMutate: () => onMutate(),
    onError: (e) => onError(e)
  })

  // const createByCustomerMutation = useMutation({
  //   mutationFn: createCustomerFinanceReturnFunds,
  //   onSuccess: () => onSuccess(),
  //   onMutate: () => onMutate(),
  //   onError: (e) => onError(e)
  // })

  const changeStatusMutation = useMutation({
    mutationFn: changeReturnStatus,
    onSuccess: () => onSuccess(),
    onMutate: () => onMutate(),
    onError: (e) => onError(e)
  })

  const changeStatusByAdminMutation = useMutation({
    mutationFn: changeReturnStatusByAdmin,
    onSuccess: () => onSuccess(),
    onMutate: () => onMutate(),
    onError: (e) => onError(e)
  })

  return {
    createMutation,
    //createByCustomerMutation,
    changeStatusMutation,
    changeStatusByAdminMutation
  }
}